<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">

  <div v-if="open">
    <v-overlay
        z-index="49"
    ></v-overlay>

    <v-navigation-drawer
        absolute class="view"
        permanent
        right
        width="800"
    >
      <!--<v-card>-->
      <v-btn v-if="shipping.code && this.shippings.length > 1" :disabled="this.shippings.length < 2" color="primary" fab
             fixed
             left outlined
             small
             top
             @click="onClickPrevious()">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <v-btn v-if="shipping.code && this.shippings.length>1" :disabled="this.shippings.length < 2" color="primary" fab
             fixed
             outlined right
             small
             top
             @click="onClickNext()">
        <v-icon>mdi-arrow-right</v-icon>
      </v-btn>
      <v-content v-if="activeTab==='Info'">
        <v-card-title v-if="shipping.code" class="headline">
          {{ shipping.code }}
          <v-btn :color="ShippingConst.color(shipping.status)" class="headline_status" small tile>
            {{ ShippingConst.map(shipping.status) }}
          </v-btn>
        </v-card-title>

        <!--<v-card-text>Info</v-card-text>-->

        <div class="contents">
          <v-card>
            <v-container class="container--fluid pt-0">
              <v-row>
                <v-col class="col-3">
                  <a :href="shipping.qr" target="_blank" style="margin-top: 12px;display: inline-block;"><qrcode-vue :value="shipping.qr" :size="150" level="H"/></a>
                </v-col>
                <v-col>

                  รถ: {{ (shipping.truck && shipping.truck.plate) ? shipping.truck.plate : shipping.truck_code }}<br/>
                  ส่ง: {{ $helper.date_format_short(shipping.date_delivery) }}<br/>
                  ปริมาตร {{
                    $helper.number_format(shipping.total_volume_cbm)
                  }}/{{ $helper.number_format(shipping.max_cbm) }}cbm <br/>
                  น้ำหนัก {{
                    $helper.number_format(shipping.total_weight_kg)
                  }}/{{ $helper.number_format(shipping.max_weight) }}kg <br/>
                  หมายเหตุ:
                  {{ shipping.comment }}


                </v-col>
                <v-col style="border-left: 1px solid #ccc;">
                  <table style="width: 100%;">
                    <tr>
                      <td>รายการค่าใช้จ่าย</td>
                      <td class="text-right">คำนวน</td>
                      <td class="text-right">ใบทริป</td>
                    </tr>
                    <tr>
                      <td>ค่าน้ำมัน</td>
                      <td class="text-right">{{ shipping.route?$helper.number_format(shipping.route.fuel_cost):'' }}</td>
                      <td class="text-right">{{ $helper.number_format(shipping.fuel_cost) }}</td>
                    </tr>
                    <tr>
                      <td>ค่าที่พัก</td>
                      <td class="text-right">{{shipping.route?$helper.number_format(shipping.route.accommodation_cost):'' }}</td>
                      <td class="text-right">{{ $helper.number_format(shipping.accommodation_cost) }}</td>
                    </tr>
                    <tr>
                      <td>ค่าเบี้ยเลี้ยง</td>
                      <td class="text-right">{{ shipping.route?$helper.number_format(shipping.route.driver_cost):'' }}</td>
                      <td class="text-right">{{ $helper.number_format(shipping.driver_cost) }}</td>
                    </tr>
                    <tr>
                      <td>ค่าโอที</td>
                      <td class="text-right">{{ shipping.route?$helper.number_format(shipping.route.ot_cost):'' }}</td>
                      <td class="text-right">{{ $helper.number_format(shipping.ot_cost) }}</td>
                    </tr>
                    <tr>
                      <td>ค่าทางด่วน</td>
                      <td class="text-right">{{ shipping.route?$helper.number_format(shipping.route.motorway_cost):'' }}</td>
                      <td class="text-right">{{ $helper.number_format(shipping.motorway_cost) }}</td>
                    </tr>
                    <tr>
                      <td style="">Total</td>
                      <td class="text-right" style="border-top: solid 1px #000;border-bottom: 3px double rgb(0, 0, 0);">
                        {{ shipping.route?$helper.number_format(shipping.route.total_cost):'' }}
                      </td>
                      <td class="text-right" style="border-top: solid 1px #000;border-bottom: 3px double rgb(0, 0, 0);">
                        {{
                          $helper.number_format(shipping.accommodation_cost * 1 + shipping.driver_cost * 1 + shipping.motorway_cost * 1 + shipping.fuel_cost * 1 + shipping.ot_cost * 1)
                        }}
                      </td>
                    </tr>
                  </table>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
          <!--{{shipping}}-->

          <v-checkbox
              v-model="filterCashOnly"
              label="แสดงเฉพาะเงินสด"
              class="ml-4 mt-0"
              hide-details
              dense
          ></v-checkbox>

                    <v-simple-table class="itemTable">
                      <template v-slot:default>
                        <thead>
                        <tr class="ItemHead">
                          <th class="text-left"></th>
                          <th class="text-left">ออเดอร์</th>
                          <th class="text-left">ลูกค้า</th>
                          <th class="text-left">สถานะลูกหนี้</th>
                          <th class="text-left">จังหวัด</th>
                          <th class="">ผล</th>
                          <!--<th class="text-right">ราคาขาย</th>-->
<!--                          <th class="text-right">จน.</th>-->
                          <!--<th class="text-right">รวม in.vat</th>-->
                        </tr>
                        </thead>
                        <tbody v-for="(ship_stop, index) in filteredOptimized"
                               :key="index"
                               :currentIndex="index"
                               class="ItemRow"
                               @click="shipping.orders[ship_stop.code] && $root.$emit('openOrder', {id:shipping.orders[ship_stop.code].id,orders:shipping.route?.results?.relations?.orders,order:shipping.orders[ship_stop.code]})"
                        >
                        <tr>
                          <td class="text-right">{{index+1}}</td>
                          <td>{{ shipping.orders[ship_stop.code]?.code }}</td>
                          <td>{{ shipping.orders[ship_stop.code]?.customer?.nickname }}</td>
                          <td>{{ shipping.orders[ship_stop.code]?.credit_term > 0 ? 'เครดิต ' + shipping.orders[ship_stop.code]?.credit_term : 'เงินสด' }}</td>
                          <td>{{ shipping.orders[ship_stop.code]?.shipping_address?.district?.city?.province?.name }}</td>
                          <td>{{ shipping.orders[ship_stop.code]?.do_status }}</td>
                        </tr>
                        </tbody>
                      </template>
                    </v-simple-table>


          <v-footer class="pb-10">
            <v-container>
              <v-row v-for="(post, index) in shipping.timeline"
                     :key="index"
                     :shipping="shipping">
                <v-col>
                  <span style="zoom: 0.6"><Avatar :active="true"
                                                  :user="$store.state.users.id_map[post.user_id]"></Avatar></span>
                  <span class="caption ml-4">{{ $helper.date_format_short_with_time(post.created_at) }}</span><br/>
                  <span class="ml-4">{{ post.content }}</span>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="">
                  <v-textarea
                      v-model="user_comment"
                      height="40px"
                      label="Comment"
                      outlined
                  ></v-textarea>
                </v-col>
                <v-col class="col-2">
                  <v-btn
                      :loading="user_comment_saving"
                      class="primary" @click="postComment()">
                    Send
                  </v-btn>
                </v-col>
              </v-row>


            </v-container>
          </v-footer>
        </div>
      </v-content>


      <v-content v-if="activeTab==='Timeline'">
        <v-card-title class="headline">{{ shipping.code }}</v-card-title>
        <v-card-text>Timeline</v-card-text>


      </v-content>

      <v-content v-if="activeTab==='Quotation'">
        <iframe :src="quotationUrl" class="quotation_iframe"></iframe>
      </v-content>


      <v-app-bar bottom fixed height="60">
        <!--<v-footer bottom>-->
        <!--<template v-slot:default>-->
        <v-tabs
            v-model="active_tab"
            bottom
            center-active
            centered
            fixed
            height="60"
            slider-color="slider"
            slider-size="5"
        >


          <TabForDialog v-for="(tab, index) in tabs" :key="index" :tab="tab"></TabForDialog>

        </v-tabs>
        <!--</template>-->
      </v-app-bar>


      <a :href="'/api/route/'+shipping.route_id+'/document?t/&token='+$helper.access_token()"
         target="_blank">
        <v-btn
            v-if="shipping.status>=ShippingConst.STATUS_DO_CONFIRMED_WAIT_STOCK"
            :loading="is_LoadSubmitShipping" bottom class="close-button primary" fixed float right
            style="margin-right: 250px;bottom: 18px"
            tiled
            x-large
        >
          ใบอนุมัติ
        </v-btn>
      </a>
      <a :href="'/api/route/'+shipping.route_id+'/route_google_route?t/&token='+$helper.access_token()"
         target="_blank">
        <v-btn
            :loading="is_LoadSubmitShipping" bottom class="close-button primary" fixed float right
            style="margin-right: 100px;bottom: 18px"
            tiled
            x-large
        >
          เส้นทาง
        </v-btn>
      </a>


      <v-btn :loading="is_LoadSubmitShipping" bottom class="close-button" color="primary" fab fixed float
             right
             @click="()=>{this.close()}">
        <v-icon>mdi-close</v-icon>
      </v-btn>


      <v-btn
          v-if="
                shipping.status===ShippingConst.STATUS_APPROVED_PENDING_SYNC ||
                shipping.status===ShippingConst.STATUS_SUBMITTED_PENDING_CONFIRM ||
                shipping.status===ShippingConst.STATUS_SUBMITTED_PENDING_CUSTOMER ||
                shipping.status===ShippingConst.STATUS_REJECT
              "
          :loading="is_LoadSubmitShipping" bottom class="delete-button" color="error" fab fixed float
          left
          style="z-index: 5"
          @click="deletingObject(shipping)">
        <v-icon>mdi-delete</v-icon>
      </v-btn>


      <!--</v-card>-->
      <!--</v-dialog>-->
    </v-navigation-drawer>

  </div>
</template>
<style lang="scss" scoped>
.contents {
  height: calc(100vh - 80px);
  overflow: auto;
}

.quotation_iframe {
  width: 100%;
  bshipping: 0;
  height: calc(100vh - 80px);
  overflow: auto;
}

.quotation_share {
  margin-bottom: 90px;
}

.headline {
  padding-top: 20px;
  padding-bottom: 0;
  height: 56px;
}

.headline_status {
  margin-left: 10px;
}

.overlay {
  z-index: 50 !important;
}

.view {
  z-index: 60 !important;

  .v-card__title {
    padding-left: 68px;
    padding-right: 68px;
  }

  .v-app-bar {
    padding-right: 96px;
  }
}

.item-qty {
  min-width: 80px;
}

.list-container {
  .list-row {
    position: relative;
    height: auto;
    margin-left: 0;
  }

  .list-row {
    font-size: 20px;
  }

  @media all and (max-width: 599px) {
    .list-row {
      font-size: 16px;
    }
  }
  @media all and (min-width: 600px) and (max-width: 720px) {
    .list-row {
      font-size: 18px;
    }
  }
  @media all and (min-width: 720px) and (max-width: 960px) {
    .list-row {
      font-size: 20px;
    }
  }
}

.itemTable {

  line-height: 1.2;
}

.ItemHead {
  th {
    font-size: 16px;
  }
}

.ItemRow {
  td {
    font-size: 16px;
    padding: 0 4px;
  }

  td:first-child {
    font-size: 16px;
    padding-left: 8px;
  }

  td:last-child {
    padding-right: 8px;
  }

}

</style>
<script lang="ts">


import {Customer} from '@/models/Customer'
import {SimpleResponse} from '@/models/Model'
import {DataShipping, Shipping, ShippingConst} from '@/models/Shipping'
import {Timeline, TimelineConst} from '@/models/Timeline'
import {User, UserConst} from '@/models/User'
import md5 from 'md5'
import {Component, Vue} from 'vue-property-decorator'
import CreditBar from '../components/Customer/CreditBar.vue'
import TypeBadge from '../components/Customer/TypeBadge.vue'
import ItemRow from '../components/Shipping/ItemRow.vue'
import StatusBadge from '../components/Shipping/StatusBadge.vue'
import TabForDialog from '../components/TabForDialog.vue'
import Avatar from '../components/User/Avatar.vue'
import router from '../router'
import Helper from '../services/Helper.js'
import QrcodeVue from 'qrcode.vue'

@Component({
  components: {QrcodeVue, Avatar, TypeBadge, TabForDialog, ItemRow, CreditBar, StatusBadge},
})
export default class ShippingDialog extends Vue {

  open = false

  isOpenSaleCondition = false
  isSaveSaleCondition = false

  md5 = md5

  index = 0
  shippings: Shipping[] = []
  activeTab: string = 'Info'
  ShippingConst = ShippingConst

  active_tab = 0

  tabs_info = {
    key: 'info',
    name: 'ข้อมูล',
    click: () => this.click_tab('Info'),
    path: null,
    permissions: [],
    isLoad: false,
    badge: false,
    badge_number: 0,
  }
  tabs_quotation = {
    key: 'quotation',
    name: 'ใบเสนอราคา',
    click: () => this.click_tab('Quotation'),
    path: null,
    permissions: [],
    isLoad: false,
    badge: false,
    badge_number: 0,
    isAdded: false,
  }
  tabs_timeline = {
    name: 'Timeline',
    click: () => this.click_tab('Timeline'),
    path: null,
    permissions: [],
    isLoad: false,
    badge: true,
    badge_number: 5,
  }
  tabs = [
    this.tabs_info,
  ]
  dialog: boolean = false
  user_comment: string = ''
  user_comment_saving: boolean = false
  shipping: Shipping = new Shipping()
  isLoadShipping = false
  is_LoadSubmitShipping = false
  is_ApprovingComOption = false
  sales: User[] = []
  isPriceLessThanLimit = false
  is_open_quotation: boolean = false
  quotationUrl = ''
  filterCashOnly: boolean = false

  get filteredOptimized() {
    const optimized = this.shipping.route?.results?.optimized?.filter(it => it.action === 'UNLOAD' && it.code != 'base') || []
    if (!this.filterCashOnly) {
      return optimized
    }
    return optimized.filter(ship_stop => {
      const order = this.shipping.orders?.[ship_stop.code]
      return order && (order.credit_term === 0 || order.credit_term === null)
    })
  }

  get isInShippingSales() {
    const user_code = this.$store.state.$user.employee_code
    return this.sales.filter(user => user.employee_code == user_code).length > 0
  }


  get isApproveComOptionAble() {
    switch (this.$store.state.$user.role) {
      case UserConst.ROLE_ADMIN:
        return true
      case UserConst.ROLE_CEO:
        return true
      case UserConst.ROLE_DIRECTOR:
        return true
      default:
        return false
    }


  }

  get isApproveAble() {
    switch (this.$store.state.$user.role) {
      case UserConst.ROLE_ADMIN:
        return true
      case UserConst.ROLE_CEO:
        return true
      case UserConst.ROLE_DIRECTOR:
        return true
      case UserConst.ROLE_MANAGER:
        return true
      case UserConst.ROLE_LOGISTIC:
          return true
      default:
        return false
    }


  }

  onApply: Function = () => {

  }

  openSaleCondition() {

    this.isOpenSaleCondition = true
  }

  onOpen({id, shipping, shippings, index, debug, skip_load, onApply}) {
    if (this.open) return
    console.log('Emited', {shipping, shippings, index, debug})

    this.tabs_quotation.isAdded = false
    this.tabs = this.tabs.filter(tab => tab.key != 'quotation')
    this.activeTab = 'Info'
    this.active_tab = 0
    this.filterCashOnly = false


    this.shipping = new Shipping()
    if (shipping) {
      this.shipping = shipping
    } else if (id) {
      this.shipping.id = id
    }
    if (index && shippings) {
      this.index = index
      this.shippings = shippings
    } else {
      this.index = 0
      this.shippings = []
    }

    this.open = true
    this.sales = []
    if (skip_load) {
    } else {
      this.getShipping()
    }
    this.onApply = onApply
  }

  mounted() {
    this.$root.$on('openShipping', this.onOpen)
  }

  onClickPrevious() {
    if (this.shippings.length > 1) {
      this.index = (this.index - 1) % this.shippings.length
      this.shipping = this.shippings[this.index]
      this.getShipping()
    }
  }

  onClickNext() {
    if (this.shippings.length > 1) {
      this.index = (this.index + 1) % this.shippings.length
      this.shipping = this.shippings[this.index]
      this.getShipping()
    }
  }

  click_tab(name: string): void {
    if (name === 'Cart') {
      this.close()
      router.push('/cart')
    } else {
      this.activeTab = name
    }

  }

  async postComment() {
    this.user_comment_saving = true
    let timeline = new Timeline()
    timeline.created_at = new Date()
    timeline.recordable_type = 'App\\Models\\Shipping'
    timeline.recordable_id = this.shipping.id
    timeline.user_id = this.$store.state.$user.id
    timeline.type = TimelineConst.TYPE_COMMENT
    timeline.content = this.user_comment
    try {
      await timeline.save()
      this.shipping.timeline.push(timeline)

      this.user_comment = ''
    } catch (e) {
      this.$root.$emit('onError', {error: e})
    }
    this.user_comment_saving = false

  }

  getShipping() {
    const id = this.shipping.id
    this.tabs_info.isLoad = true
    Helper.get(Helper.setting.shipping.getResourceAPI.replace('{id}', id))
        .then<{ data: DataShipping }>(({data}) => {

          console.log('getShipping', data.data)
          this.shipping = data.data


          // this.items = data.data

          //this.$store.commit('shippings_response', data)
          //this.reloadItem()
          this.tabs_info.isLoad = false
        }).catch(error => {
      if (error && error.response && error.response.status == 404) {
        this.$root.$emit('onError', {message: 'ไม่พบออร์เดอร์', error: error})
        this.close()
      } else {
        this.$root.$emit('onError', {error: error})
      }
    })

  }

  async ApproveShipping() {
    await this.SetShippingStatus(ShippingConst.STATUS_APPROVED_PENDING_SYNC)
  }

  async RejectShipping() {
    await this.SetShippingStatus(ShippingConst.STATUS_REJECT)
  }

  async CancelShipping() {
    await this.SetShippingStatus(ShippingConst.STATUS_DRAFT)
    this.close()
  }

  async ConfirmShipping() {
    if (this.isPriceLessThanLimit) {
      this.$root.$emit('onError', {message: 'ยืนยันไม่สำเร็จ รายการสินค้าบางรายการ ไม่ผ่านเงื่อนไขการขาย'})
      return
    }

    let shipping: Shipping = this.shipping

    if (!shipping.hasOwnProperty('SubmitDO')) {
      shipping = Object.setPrototypeOf(shipping, Shipping.prototype)
    }
    this.is_LoadSubmitShipping = true
    // debugger
    try {
      shipping = await shipping.SubmitDO()
      this.$store.commit('carts_remove', shipping)
      console.log(this.onApply)
      this.onApply && this.onApply()
      this.close()

      this.$root.$emit('onSuccess', {message: 'ส่งออเดอร์เรียบร้อย'})
    } catch (e) {
      // alert(e);
    }
    this.is_LoadSubmitShipping = false
  }

  close() {
    this.open = false
  }

  async SetShippingStatus(status: number) {
    if (this.shipping.status == status) return
    let shipping: Shipping = new Shipping()
    shipping.id = this.shipping.id
    shipping.mode = 'status'
    if (!shipping.hasOwnProperty('SetStatus')) {
      shipping = Object.setPrototypeOf(shipping, Shipping.prototype)
    }
    this.is_LoadSubmitShipping = true
    // debugger
    try {
      shipping = await shipping.SetStatus(status)
      this.shipping = shipping
    } catch (e) {
      // alert(e);
    }
    this.is_LoadSubmitShipping = false
    return shipping
  }

  async deletingObject(shipping: Shipping) {
    this.$confirm('ยืนยันลบข้อมูล?').then(res => {
      if (res) {
        this.deleteObject(shipping)
        this.close()
      } else {

      }
    })

  }

  async deleteObject(shipping: Shipping) {
    // this.is_LoadSubmitShipping = true
    try {
      if (!shipping.hasOwnProperty('delete')) {
        shipping = Object.setPrototypeOf(shipping, Shipping.prototype)
      }
      const response: SimpleResponse = await shipping.delete()

      this.shippings = this.shippings.filter(object => object.id != this.shipping?.id)

      this.$root.$emit('onSuccess', {message: response.toString()})
    } catch (e) {
      console.log(e)
      this.$root.$emit('onError', {error: e})
    }

  }

  share(shipping: Shipping) {

  }

};

</script>
